<template>
	<div :style="wrapperStyle">
		<div class="loader-stripes" :style="progressStyle" />
	</div>
</template>

<script setup>
	import { defineProps, computed } from 'vue'

	const props = defineProps({
		settings: {
			type: Object,
			required: true
		},
		progress: {
			type: Number,
			default: 0
		}
	})

	const wrapperStyle = computed(() => {
		const { spacing, size } = props.settings
		const [mt, mr, mb, ml] = spacing?.margin || [0, 0, 0, 0]
		const [pt, pr, pb, pl] = spacing?.padding || [0, 0, 0, 0]
		return {
			width: size?.width || '100%',
			height: `${size?.height}px` || '50px',
			minWidth: size?.minWidth || undefined,
			minHeight: size?.minHeight || undefined,
			maxWidth: size?.maxWidth || undefined,
			maxHeight: size?.maxHeight || undefined,
			margin: `${mt}px ${mr}px ${mb}px ${ml}px`,
			padding: `${pt}px ${pr}px ${pb}px ${pl}px`,
			overflow: 'hidden',
			position: 'relative',
			backgroundColor: props.settings.background?.[0] || '#ececec'
		}
	});

	const progressStyle = computed(() => {
		const stripe1 = props.settings.background?.[1] || '#000000'
		const stripe2 = props.settings.background?.[2] || stripe1
		return {
			width: `${props.progress}%`,
			height: '100%',
			backgroundImage: `repeating-linear-gradient(
      45deg,
      ${stripe1},
      ${stripe1} 55px,
      ${stripe2} 55px,
      ${stripe2} 110px
    )`,
			animation: 'slide 1s linear infinite'
		}
	})
</script>

<style scoped>
	@keyframes slide {
		0% {
			background-position: 0 0;
		}
		100% {
			background-position: 40px 0;
		}
	}
</style>
